import { Button } from '@consta/uikit/Button'
import { Show } from '@library/components'
import cn from 'classnames'
import type { FC } from 'react'

import {
  IconExpandFull,
  IconExpandHalfDown,
  IconExpandHalfUp,
  IconExpandMinimized,
} from '../../../Icons'
import { useLayoutContext } from '../../context'
import type { ShowMode } from '../types'
import css from './FooterButton.css'

type FooterControlButtonsProps = {
  disabled?: boolean
  onChangeMode?: (mode: ShowMode) => void
}

export const FooterButtons: FC<FooterControlButtonsProps> = ({ disabled, onChangeMode }) => {
  const {
    footerApi: { leftButton, rightButton, showMode },
    noFullMode,
  } = useLayoutContext()

  const LeftButtonIcon = showMode === 'none' ? IconExpandHalfUp : IconExpandMinimized
  const RightButtonIcon = showMode === 'full' ? IconExpandHalfDown : IconExpandFull

  const handleLeftButton = () => {
    const newMode = leftButton()
    onChangeMode?.(newMode)
  }

  const handleRightButton = () => {
    const newMode = rightButton()
    onChangeMode?.(newMode)
  }

  return (
    <div className={css.right}>
      <Button
        disabled={disabled}
        className={cn({ [css.minimized]: showMode !== 'none' })}
        view="clear"
        size="xs"
        iconLeft={LeftButtonIcon}
        onlyIcon={true}
        onClick={handleLeftButton}
      />
      <Show when={!noFullMode}>
        <Button
          disabled={disabled}
          view="clear"
          size="xs"
          iconLeft={RightButtonIcon}
          onlyIcon={true}
          onClick={handleRightButton}
        />
      </Show>
    </div>
  )
}
